import { shallowRef } from 'vue';
import type { MindboxSearchLabelMaps } from '@/pages/listing/lib/mindbox/searchLabelMaps';

let labelMapsPromise: Promise<MindboxSearchLabelMaps> | null = null;

/**
 * Загружает карты лейблов Mindbox один раз и переиспользует общий promise между листингами.
 */
const loadMindboxSearchLabelMaps = () => {
  if (!labelMapsPromise) {
    labelMapsPromise = import('@/pages/listing/lib/mindbox/searchLabelMaps').then((module) =>
      module.getMindboxSearchLabelMaps(),
    );
  }

  return labelMapsPromise;
};

/**
 * Возвращает карты лейблов для Mindbox search payload с загрузкой по явному запросу.
 */
export const useLazyMindboxSearchLabelMaps = () => {
  const labelMaps = shallowRef<MindboxSearchLabelMaps | null>(null);

  /**
   * Запускает загрузку карт и сохраняет результат для синхронной сборки payload на unload.
   */
  const load = () => {
    void loadMindboxSearchLabelMaps().then((maps) => {
      labelMaps.value = maps;
    });
  };

  return {
    labelMaps,
    load,
  };
};
